import PropTypes from 'prop-types'

export const unit = PropTypes.oneOf(['metric', 'imperial', 'percent', 'percentgdv', 'percentcost', 'fixed'])
export const unitType = PropTypes.oneOf(['percent-fixed', 'percentgdv-percentcost-fixed'])

export const numberType = PropTypes.oneOf(['area', 'area-large', 'currency', 'integer', 'number'])

export const unitedNumber = PropTypes.shape({
  value: PropTypes.number,
  unit,
})

export const inputPropType = {
  active: PropTypes.bool,
  allowZero: PropTypes.bool,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  prefix: PropTypes.node,
  readOnly: PropTypes.bool,
  small: PropTypes.bool,
  suffix: PropTypes.node,
  value: PropTypes.number,
}
